import { AlertTriangle } from 'lucide-react';
import { Alert } from '@components/common/Alert';
import { Dialog } from '@components/common/Dialog';
import Button from '@components/common/Button';

interface Props {
  dashboardName: string;
  isOpen: boolean;
  isLoading?: boolean;
  errorMessage?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DashboardDeleteModal({
  dashboardName, isOpen, isLoading = false, errorMessage, onCancel, onConfirm,
}: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open && !isLoading) onCancel(); }}>
      <div className="space-y-4 p-6">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" aria-hidden="true" />
          <h2 className="text-lg font-semibold text-content-primary">Delete Dashboard?</h2>
        </div>

        <p className="text-sm text-content-secondary">
          Are you sure you want to delete <strong>{dashboardName}</strong>? This removes the dashboard
          and its widgets for everyone with access.
        </p>

        {errorMessage && (
          <Alert variant="danger">{errorMessage}</Alert>
        )}

        <div className="flex gap-3 pt-2" role="group" aria-label="Delete dashboard confirmation actions">
          <Button variant="secondary" onClick={onCancel} disabled={isLoading}>Cancel</Button>
          <Button variant="danger" onClick={onConfirm} loading={isLoading}>
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
